import React from "react";
import FormContainer from "./FormContainer";
import Initializers from "./Initializers";
import useFormState from "./useFormState";
import Success from "./Success";

export default function SubscriptionContainer() {
	const { success } = useFormState();

	return (
		<>
			<Initializers />
			{success ? <Success /> : <FormContainer />}
		</>
	);
}
